import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input, Switch} from '@progress/kendo-react-inputs';
import {DropDownList } from '@progress/kendo-react-dropdowns';
//import DateTimePicker from 'react-datetime-picker';
import { connect } from 'react-redux';
import { getRegions, getDistricts, fetchStates, geteventCategories } from '../../../../../Redux/Actions/CommonActions';
import { Alert } from 'reactstrap';
import './Events.scss';
import ReactFileReader from 'react-file-reader';
import DateTimePicker from 'react-datetime-picker';

import PlacesAutocomplete ,  {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng, columnMenu
} from 'react-places-autocomplete';
import '@progress/kendo-react-common'
import '@progress/kendo-date-math'

class EventForm extends Component {
    constructor(props) {
        super(props);

        let e = { ...this.props.dataItem }
        if (!e.eventId) {
            e.startDate = new Date();
            e.endDate = new Date();
        }
        else {
            e.startDate = new Date(e.startDate);
            e.endDate = new Date(e.endDate);
        }
        this.state = {
            alert: { visible: false },
            eventInEdit: e || null,
            value: [],
            selectedRegion: e.region || null,
            selectedDistrict: e.district || null,
            //selectedState: e.state || null,
            districts: [],
            file: null,
            selectedCategory: e.eventCategory || null,
            Banner: false,
            address: '',
            SecondaryAddress: '',
            displayAddress: e.address1 || '',
            startMessage: '',
            endMessage: '',
            categoryMessage: '',
            stateMessage: '',
            regionMessage: '',
            districtMessage: '',
            Address1: e.address1 || "",
            Address2: e.address2 || "",
            City: e.city || "",
            StateId: e.stateId || 0,
            State: e.state || { id: 0, name: "" },
            Zip: e.zip || '',
            events: this.props.allEvents ? this.props.allEvents.data : []
        };
    };

    componentDidMount() {
        this.setState({
            Banner:this.props.dataItem.Banner
        })
        this.props.getRegions();
        this.props.fetchStates();
        this.props.geteventCategories();
    }

    handleAddressChange = address => {
        this.setState({
            displayAddress: address,
            Address1: address,
            Address2: "",
            City: "",
            StateId: 0,
            State: { id: 0, name: "" },
            Zip: "",
            stateMessage: ''

        });
    };

    handleSelect = address => {
        geocodeByAddress(address)
            .then(results => {
                results.map((addressResults) => {
                    var mailingInformation = {
                        Address1: "",
                        Address2: "",
                        City: "",
                        StateId: 0,
                        State: { id: 0, name: "" },
                        Zip: ""
                    }
                    addressResults.address_components.map((result) => {
                        if (result.types.includes("street_number")) {
                            mailingInformation.Address1 = result["short_name"];
                            this.state.displayAddress = result["short_name"];
                        }
                        if (result.types.includes("route")) {
                            mailingInformation.Address1 = mailingInformation.Address1 + " " + result["short_name"];
                            this.state.displayAddress = this.state.displayAddress + " " + result["short_name"];
                        }
                        if (result.types.includes("locality")) {
                            mailingInformation.City = result["short_name"];
                            this.state.displayAddress = this.state.displayAddress + " " + result["short_name"];
                        }
                        if (result.types.includes("administrative_area_level_1")) {
                            mailingInformation.State= result["short_name"];
                            this.state.displayAddress = this.state.displayAddress + " " + result["short_name"];
                            var stateObj = this.props.common.states.find((stateObj) => {

                                if (stateObj.name === result["short_name"].toString()) {
                                    return stateObj
                                }
                            })
                            mailingInformation.StateId = stateObj.id;
                            mailingInformation.State = stateObj;
                        }
                        if (result.types.includes("postal_code")) {
                            mailingInformation.Zip = result["short_name"];
                            this.state.displayAddress = this.state.displayAddress + " " + result["short_name"];
                        }
                    });
                    this.setState(mailingInformation);
                })

            }).catch ((error) => {
                this.setAlert(true, (error && error.message ? error.message : 'Unable to select the location.'), 'danger')
            });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        let isValid = true;
        const edited = this.state.eventInEdit;
        let startTime = new Date(edited.startDate);
        let endTime = new Date(edited.endDate);
        let currentTime = (new Date());

        let selectedCategory = this.state.selectedCategory;
        let selectedRegion = this.state.selectedRegion;
        let selectedDistrict = this.state.selectedDistrict;
        let selectedLocation = this.state.displayAddress;

        // REMOVING THIS REQUIREMENT SO WE CAN EDIT OLD EVENTS
        //if (startTime < currentTime) {
        //    isValid = false;
        //    if (startTime.getFullYear() < currentTime.getFullYear() || startTime.getMonth() < currentTime.getMonth() || startTime.getDate() < currentTime.getDate()) {
        //        this.setState({
        //            startMessage: "Start date cannot be before current date"
        //        })
        //    }
        //    else {
        //        this.setState({
        //            startMessage: 'Start time cannot be before current time'
        //        })
        //    } 
        //}

        if (startTime > endTime) {
            isValid = false;
            //if (startTime.getFullYear() > endTime.getFullYear() || startTime.getMonth() > endTime.getMonth() || startTime.getDate() > endTime.getDate()) {
            //    this.setState({
            //        endMessage: 'End date must be after start date'
            //    })
            //}
            //else {
            //    this.setState({
            //        endMessage: 'End time must be after start time'
            //    })
            //}
            this.setState({
                endMessage: 'End time must be after start time'
            })
        }

        if (!selectedCategory) {

            isValid = false;

            this.setState({
                categoryMessage: 'Category is required'
            })

        }

        //if (!selectedDistrict) {

        //    isValid = false;

        //    this.setState({
        //        districtMessage: 'District is required'
        //    })

        //}

        //if (!selectedRegion) {

        //    isValid = false;

        //    this.setState({
        //        regionMessage: 'Region is required'
        //    })

        //}

        if (selectedLocation) {

            //isValid = false;

            //this.setState({
            //    stateMessage: 'Location Address is required (Type to get the list and select one)'
            //})

            if (!this.state.State || !this.state.StateId) {

                isValid = false;

                this.setState({
                    stateMessage: 'Location Address is required (Type to get the list and select one)'
                })
            }
        }  

        if (isValid) {
            console.log("this.state.file", this.state.file);
            edited.ImageFile = this.state.file ? {
                name: this.state.file.fileList[0].name,
                source: this.state.file.base64,
                extension: this.state.file.fileList[0].type
            } : null;
            edited.Address1 = this.state.Address1;
            edited.Address2 = this.state.Address2;
            edited.City = this.state.City;
            edited.StateId = this.state.StateId;
            edited.State = this.state.State;
            edited.Zip = this.state.Zip;
            edited.Banner = this.state.Banner;
            this.props.save({
                ...this.state.eventInEdit
            });
            this.props.cancel();
        }
    }

    onDialogInputChange = (event) => {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state.eventInEdit;
        edited[name] = value;
        edited.isActive = true;
        this.setState({
            eventInEdit: edited
        });
    };

    checkboxChange = () => {
        this.setState({
            Banner: !this.state.Banner
        })
    }

    urlValidation = (event) => {
        let value = event.target.value;

    };

    handleRegionChange = (event) => {
        var selectedRegion = event.target.value;
        const edited = this.state.eventInEdit;
        edited.regionId = selectedRegion.id;
        edited.region = selectedRegion;
        this.state.eventInEdit.district = null;
      
		this.setState({
            selectedRegion: selectedRegion,
            selectedDistrict: null,
            eventInEdit: edited,
            regionMessage: ''
		})
        this.props.getDistricts(selectedRegion.id)
       
    };

	handleDistrict =(event) => {
        const edited = this.state.eventInEdit;
        edited.districtId = event.target.value.id;
        edited.district = event.target.value;
		this.setState({
            selectedDistrict:event.target.value,
            eventInEdit: edited,
            districtMessage: ''
		})
    };

  //  handleStateChange =(event) => {
  //      const edited = this.state.eventInEdit;
  //      edited.stateId = event.target.value.id;
  //      edited.state = event.target.value;

		//this.setState({
  //          selectedState:event.target.value,
  //          eventInEdit: edited
		//})
  //  };

    handleCategoryChange=(event) => {
        const edited = this.state.eventInEdit;
        edited.eventCategoryID = event.target.value.id;
        edited.eventCategory = event.target.value;

		this.setState({
            selectedCategory:event.target.value,
            eventInEdit: edited,
            categoryMessage: ''
		})
    };

    handleStartDate = (date) => {
        const edited = this.state.eventInEdit;
        edited.startDate = date;
        this.setState({
            eventInEdit: edited,
            startMessage:''
        });
    };

    handleEndDate = (date) => {
        const edited = this.state.eventInEdit;
        edited.endDate = date;
		this.setState({
            eventInEdit: edited,
            endMessage:''
		});
    };

    handleFiles = (files) => {
		console.log("files", files.fileList[0].name);
        this.setState({
            file: files
		})
    }

    setAlert = (visible, message, color) => {
        let alert = {
            color: color,
            visible: visible,
            message: message
        }
        this.setState({
            alert: alert
        })

    }

    handleAutocompleteErr = (status, clearSuggestions) => {
        this.setAlert(true, 'Google Maps API returned error with status: ' + status, 'danger');
        setTimeout(() => {
            this.setAlert(false, "");
        }, 5000)
        clearSuggestions()
    }

    handleCloneEvent = (event) => {

        var cloneItem = Object.assign({}, event.target.value);
        cloneItem.startDate = new Date();
        cloneItem.endDate = new Date();
        delete cloneItem.eventId;

        let eventCategory = {
            id: cloneItem.eventCategoryID,
            name: cloneItem.eventCategory
        };
        let region = {
            id: cloneItem.regionId,
            name: cloneItem.region,
        };
        let district = {
            id: cloneItem.districtId,
            name: cloneItem.district
        };
        let state = {
            id: cloneItem.stateId,
            name: cloneItem.state
        };

        cloneItem.eventCategory = eventCategory;
        cloneItem.region = region;
        cloneItem.district = district;
        cloneItem.state = state;

		this.setState({
            selectedCategory: cloneItem.eventCategory,
            selectedDistrict: cloneItem.district,
            selectedRegion: cloneItem.region,
            displayAddress: cloneItem.address1,
            eventInEdit: cloneItem,
            Banner: cloneItem.Banner,
            startMessage: '',
            endMessage: '',
            categoryMessage: '',
            stateMessage: '',
            regionMessage: '',
            districtMessage: '',
            Address1: cloneItem.address1 || "",
            Address2: cloneItem.address2 || "",
            City: cloneItem.city || "",
            StateId: cloneItem.stateId || 0,
            State: cloneItem.state || { id: 0, name: "" },
            Zip: cloneItem.zip || '',
		})
    };
	render() {
        return (
            <div className="eventDialog">
                <Dialog onClose={this.props.cancel}>
                    <Alert
                        color={this.state.alert.color}
                        isOpen={this.state.alert.visible}
                        style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
                    >
                        {this.state.alert.message}
                    </Alert>
                    {!this.state.eventInEdit.eventId ?
                        <div>
                            <h2 className="adjust-dist-title2">Create an Event</h2>
                            <div className="cloneEventContainer col-md-12">
                                <label>Clone Event</label>
                                <DropDownList
                                    data={this.state.events}
                                    onChange={this.handleCloneEvent}
                                    textField="title"
                                    dataItemKey="eventId"
                                    value={this.state.eventInEdit.eventCategory}
                                />
                            </div>
                        </div>
                        :
                        <h2 className="adjust-dist-title2">Edit Event</h2>}
                    <form className="user-form eventForm" onSubmit={this.handleSubmit}>
                        {/* <div className="row"> */}
                            <div className="form-group col-md-6">
                                <h3 className="callout">EVENT DETAILS</h3>
                                <div className="form-group col-md-12">
                                    <label htmlFor="title">Title</label>
                                    <Input
                                        //required={true}
                                        type="text"
                                        name="title"
                                        id="title"
                                        value={this.state.eventInEdit.title || ''}
                                        onChange={this.onDialogInputChange}
                                    />
                                </div>

                                <div className="form-group col-md-12">
                                    <label>Description</label>
                                    <Input
                                        //required={true}
                                        type="text"
                                        name="description"
                                        value={this.state.eventInEdit.description || ''}
                                        onChange={this.onDialogInputChange}
                                    />
                                </div>
                            <div className="form-group col-md-12">
                                <label>Start Date</label>
                                <DateTimePicker                                 
                                    //required={true}
                                    disableClock={true}
                                    value={this.state.eventInEdit.startDate ? this.state.eventInEdit.startDate : new Date()  }
                                    onChange={this.handleStartDate}
                                />
                                <p className="error-message">{this.state.startMessage}</p>
                            </div>
                            {this.state.eventInEdit.startDate ? 
                            <div className="form-group col-md-12">                                
                                <label>End Date</label>                                                                
                                    <DateTimePicker
                                        disableClock={true}
                                       // required={true}
                                        value={this.state.eventInEdit.endDate ? this.state.eventInEdit.endDate : new Date() }
                                        onChange={this.handleEndDate}
                                    />
                                    <p className="error-message">{this.state.endMessage}</p>                              
                                </div>
                                : ""
                                }

                            <div className="form-group col-md-12">
                                <label>Category</label>
                                <DropDownList
                                    //required={true}
                                    data={this.props.common.eventCategories}
                                    onChange={this.handleCategoryChange}
                                    value={this.state.eventInEdit.eventCategory}
                                    textField="name"
                                    dataItemKey="id"
                                    allowCustom={true}
                                />
                                <p className="error-message">{this.state.categoryMessage}</p>
                            </div>
                            <div className="form-group col-md-12">
                                <label>Event on Banner</label>
                                <input
                                    className="checkbox"
                                    style={{width: '100%'}}
                                    name="Banner"
                                    onChange={this.checkboxChange}
                                    type="checkbox"
                                    checked={!!this.state.Banner}
                                />
                            </div>
                                <div className="form-group col-md-12">
                                    <label>Region</label>
                                    <DropDownList  
                                        //required={true}  
                                        data={this.props.common.regions}
                                        onChange={this.handleRegionChange}
                                        value={this.state.eventInEdit.region}
                                        textField="name"
                                        dataItemKey="id"
                                        allowCustom={true}
                                    />
                                    <p className="error-message">{this.state.regionMessage}</p>
                                    <label>District</label>
                                    <DropDownList
                                        //required={true}  
                                        data={this.props.common.districts}
                                        onChange={this.handleDistrict}
                                        value={this.state.eventInEdit.district}
                                        textField="name"
                                        dataItemKey="id"
                                        allowCustom={true}
                                    />
                                    <p className="error-message">{this.state.districtMessage}</p>
                                </div>
                            </div>

                            <div className="form-group col-md-6">
                                <h3 className="callout">LOCATION DETAILS</h3>
                                <div className="form-group col-md-12">
                                    <label>Location Name</label>
                                    <Input
                                        //required={true}
                                        type="text"
                                        name="location"
                                        value={this.state.eventInEdit.location || ''}
                                        onChange={this.onDialogInputChange}
                                    />
                                </div>

                                <PlacesAutocomplete
                                    value={this.state.displayAddress}
                                    onChange={this.handleAddressChange}
                                    onError={this.handleAutocompleteErr}
                                    onSelect={this.handleSelect} >
                                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div className="countiesAddContainerXX form-group col-md-12">

                                        <label>Location Address/Description</label>
                                            <input
                                            {...getInputProps({
                                                placeholder: 'Search Places...'
                                            })}
                                            />
                                            <div className="autocomplete-dropdown-container">
                                                {loading && <div><p>Loading...</p></div>}
                                                {suggestions.map(suggestion => {
                                                    const className = suggestion.active
                                                        ? 'suggestion-item--active'
                                                        : 'suggestion-item';
                                                    // inline style for demonstration purpose
                                                    const style = suggestion.active
                                                        ? {
                                                            backgroundColor: '#f0f0f0',
                                                            cursor: 'pointer',
                                                            width: '100%'
                                                            }
                                                        : {
                                                            backgroundColor: '#ffffff',
                                                            cursor: 'pointer',
                                                            width: '100%'
                                                        };
                                                    return (
                                                        <div
                                                            {...getSuggestionItemProps(suggestion, {
                                                                className,
                                                                style,
                                                            })}
                                                        >
                                                            <span>{suggestion.description}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            <p className="error-message">{this.state.stateMessage}</p>
                                        </div>
                                        )}
                                </PlacesAutocomplete>
                            {/*<div className="countiesAddContainerXX form-group col-md-12">
                                <label>Address 1</label>
                                <Input
                                    required={true}
                                    type="text"
                                    name="address1"
                                    value={this.state.eventInEdit.address1 || ''}
                                    onChange={this.onDialogInputChange}
                                />
                                <label>Address 2</label>
                                <Input
                                    type="text"
                                    name="address2"
                                    value={this.state.eventInEdit.address2 || ''}
                                    onChange={this.onDialogInputChange}
                                />
                                </div>
                                <div className="countiesAddContainer form-group col-md-12">
                                    <label>City</label>
                                    <Input
                                        required={true}
                                        type="text"
                                        name="city"
                                        value={this.state.eventInEdit.city || ''}
                                        onChange={this.onDialogInputChange}
                                    />
                                    <label>State</label>
                                    <DropDownList data={this.props.common.states}
                                        textField="name"
                                        value={this.state.eventInEdit.state}
                                        dataItemKey="id"
                                        onChange={this.handleStateChange}
                                        required={true}
                                    />
                                </div>*\}
                                <div className="form-group col-md-6">
                                    <h3 className="callout">FILE UPLOAD</h3>
                                {/* </div> */}

                                <div className="form-group col-md-12">
                                    <label>URL Label</label>
                                    <Input
                                    type="text"
                                    name="externalURLLabel"
                                    value={this.state.eventInEdit.externalURLLabel || ''}
                                    onChange={this.onDialogInputChange}
                                    //required={true}
                                    maxLength='8'
                                    />
                            </div>

                            <div className="form-group col-md-12">
                                <label>External URL</label>
                                <Input
                                    type="url"
                                    //required={true}  
                                    name="externalURL"
                                    value={this.state.eventInEdit.externalURL || ''}
                                    onChange={this.onDialogInputChange}
                                    onBlur={this.urlValidation}
                                />
                            </div>

                                <div className="form-group col-md-6 productUploads">
                                    <label>Event Image</label>
                                    <ReactFileReader base64={true} multipleFiles={false} handleFiles={this.handleFiles} >
                                        <p className='btnPrimary'>
                                            <i className="fas fa-file-upload"></i>
                                            <span>Upload File</span>
                                        </p>
                                    </ReactFileReader>
                                    {/*fileTypes={[".jpg",".jpeg",".png"]} */}
                                </div>
                                <div className="col-md-12 productUploads">
                                    {
                                        this.state.file ?
                                            <img alt="" src={this.state.file.base64} />
                                        : (this.state.eventInEdit.ImageURL ? <img alt="" src={this.state.eventInEdit.ImageURL} /> : "")
                                    }
                                </div>
                            </div>
                        {/* </div> */}

                        {/* <div className="eventActions"> */}
                            <DialogActionsBar>
                                <div className="adjust-btns">
                                    <div className="form-group">
                                        <button className="admin-k-button" onClick={this.props.cancel}>
                                            <i className="fas fa-times"></i>
                                            <span>CANCEL</span>
                                        </button>
                                        {!this.state.eventInEdit.eventId ? (
                                            <button type="submit" className="admin-k-button">
                                                <i className="fas fa-save"></i>
                                                <span>SAVE</span>
                                            </button>
                                        ) : (
                                            <button type="submit" className="admin-k-button">
                                                <i className="fas fa-edit"></i>
                                                <span>UPDATE</span>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </DialogActionsBar>
                        {/* </div> */}

                    </form>
                </Dialog>
            </div>
		);
	}
 }
// export default EventForm;
 function mapStateToProps(state) {
	return {
		common: state.common
	};
}

export default connect(mapStateToProps, {getRegions,getDistricts,fetchStates,geteventCategories})(EventForm);
